import { render, staticRenderFns } from "./critical-ratio-calculation-config.vue?vue&type=template&id=4da3ab27&"
import script from "./critical-ratio-calculation-config.vue?vue&type=script&lang=js&"
export * from "./critical-ratio-calculation-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports